module.exports = __webpack_public_path__ + "static/media/theme_cowboys.bfb85601.jpg";